import React, {useState} from 'react';

import createCtx from 'coreUtils/createCtx';

import {CategoryProviderProps, ICategoryContext} from './ICategoryContext';

export const [useCategoryContext, CategoryContext] = createCtx<ICategoryContext>();

export const CategoryProvider = (
	{
		children,
		cgid,
		searchInstanceKey,
		searchType,
		isITMF,
		ITMFData,
		isPrevPageLoaded,
		initialPage,
		customElements,
		customElementsConfigs,
		customElementsHideInSmallGrid
	}: CategoryProviderProps) => {
	const [showITMFBanner, setShowITMFBanner] = useState<boolean>(isITMF);

	return (
		<CategoryContext
			value={{
				cgid,
				searchInstanceKey,
				searchType,
				isITMF,
				ITMFData,
				showITMFBanner,
				setShowITMFBanner,
				isPrevPageLoaded,
				initialPage,
				customElements,
				customElementsConfigs,
				customElementsHideInSmallGrid
			}}
		>
			{children}
		</CategoryContext>
	);
};
